//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { createContext } from 'react';

/** One entry a page contributes to the header's dataset selector. */
export interface TargetSelectorOption {
  value: string;
  label: string;
  // Reads as something to do rather than something to pick (e.g. "New
  // graph…"), so it renders apart from the datasets.
  isAction?: boolean;
}

/**
 * A page taking over the header's dataset selector.  The Graphs page does this
 * so a graph it has not created yet can be selected like any other target,
 * while `activeDataset` — which every other page reads — keeps holding only
 * datasets the server actually has.
 */
export interface TargetSelectorRegistration {
  // Entries appended after the real datasets.
  options: TargetSelectorOption[];
  // Overrides the displayed selection; null follows activeDataset.
  value: string | null;
  // Replaces setActiveDataset for this page's selections.
  onSelect: (value: string) => void;
}

export interface TargetSelectorContextValue {
  registration: TargetSelectorRegistration | null;
  register: (registration: TargetSelectorRegistration | null) => void;
}

export const TargetSelectorContext =
  createContext<TargetSelectorContextValue | undefined>(undefined);
